import React, {useEffect} from "react";
import {useRef} from "react";
import {css} from "@emotion/react";

import {ISelectProps, Select} from "@pg-design/select-module";
import {form, IFormProps} from "@pg-mono/form";
import {usePrevious} from "@pg-mono/hooks";

import {SEARCH_DISTANCE_VALUES} from "../../offer/list/constants/offer_list";

interface IOwnProps extends Omit<IFormProps<ISearchFiltersFormValues>, "onSubmit"> {
    handleDistanceSubmit: (userQueryParams: {distance: number}) => void;
    setDesktopTypeBlendActive: (isOpen: boolean) => void;
    defaultValue?: number;
    menuPlacement?: ISelectProps["menuPlacement"];
}

export interface ISearchFiltersFormValues {
    distance: number | string;
}

interface IProps extends IOwnProps {}

const SearchDistanceFilterMobileC = (props: IProps) => {
    const filtersWrapperRef = useRef<HTMLElement | null>(null);
    const filtersWrapperRefHandle = (elem: HTMLElement | null) => {
        filtersWrapperRef.current = elem;
    };

    const distanceProps = props.getFieldProps("distance");
    const distanceValue = typeof distanceProps.value !== "number" ? props.defaultValue || 0 : distanceProps.value;
    const prevDistanceValue = usePrevious(distanceValue, distanceValue);

    useEffect(() => {
        if (prevDistanceValue !== distanceValue && props.handleDistanceSubmit) {
            props.handleDistanceSubmit({distance: distanceValue});
        }
    }, [distanceValue, prevDistanceValue, props.handleDistanceSubmit]);

    const distanceOption = {
        value: distanceValue,
        label: `+${distanceValue} km`
    };
    const options = SEARCH_DISTANCE_VALUES.map(mapDistanceValueToOption);

    return (
        <div css={filterHolder} ref={filtersWrapperRefHandle}>
            <Select
                value={distanceOption}
                options={options}
                name="distance"
                onChange={(newValue) => {
                    distanceProps.onChange("distance", (newValue as {value: number}).value);
                }}
                menuPlacement={props.menuPlacement}
                isBorderless
            />
        </div>
    );
};

export const SearchDistanceFilterMobile = form<ISearchFiltersFormValues, IProps>(SearchDistanceFilterMobileC);

export const mapDistanceValueToOption = (value: number) => ({
    value,
    label: `+${value} km`
});

const filterHolder = css`
    display: flex;
    flex-direction: row;
    align-items: start;
    width: 100%;

    div:nth-of-type(3) {
        margin-right: 0;
    }

    > div {
        margin-right: 0;
    }
`;
import React, {useEffect} from "react";
import {useRef} from "react";
import {css} from "@emotion/react";

import {ISelectProps, Select} from "@pg-design/select-module";
import {form, IFormProps} from "@pg-mono/form";
import {usePrevious} from "@pg-mono/hooks";

import {SEARCH_DISTANCE_VALUES} from "../../offer/list/constants/offer_list";

interface IOwnProps extends Omit<IFormProps<ISearchFiltersFormValues>, "onSubmit"> {
    handleDistanceSubmit: (userQueryParams: {distance: number}) => void;
    setDesktopTypeBlendActive: (isOpen: boolean) => void;
    defaultValue?: number;
    menuPlacement?: ISelectProps["menuPlacement"];
}

export interface ISearchFiltersFormValues {
    distance: number | string;
}

interface IProps extends IOwnProps {}

const SearchDistanceFilterMobileC = (props: IProps) => {
    const filtersWrapperRef = useRef<HTMLElement | null>(null);
    const filtersWrapperRefHandle = (elem: HTMLElement | null) => {
        filtersWrapperRef.current = elem;
    };

    const distanceProps = props.getFieldProps("distance");
    const distanceValue = typeof distanceProps.value !== "number" ? props.defaultValue || 0 : distanceProps.value;
    const prevDistanceValue = usePrevious(distanceValue, distanceValue);

    useEffect(() => {
        if (prevDistanceValue !== distanceValue && props.handleDistanceSubmit) {
            props.handleDistanceSubmit({distance: distanceValue});
        }
    }, [distanceValue, prevDistanceValue, props.handleDistanceSubmit]);

    const distanceOption = {
        value: distanceValue,
        label: `+${distanceValue} km`
    };
    const options = SEARCH_DISTANCE_VALUES.map(mapDistanceValueToOption);

    return (
        <div css={filterHolder} ref={filtersWrapperRefHandle}>
            <Select
                value={distanceOption}
                options={options}
                name="distance"
                onChange={(newValue) => {
                    distanceProps.onChange("distance", (newValue as {value: number}).value);
                }}
                menuPlacement={props.menuPlacement}
                isBorderless
            />
        </div>
    );
};

export const SearchDistanceFilterMobile = form<ISearchFiltersFormValues, IProps>(SearchDistanceFilterMobileC);

export const mapDistanceValueToOption = (value: number) => ({
    value,
    label: `+${value} km`
});

const filterHolder = css`
    display: flex;
    flex-direction: row;
    align-items: start;
    width: 100%;

    div:nth-of-type(3) {
        margin-right: 0;
    }

    > div {
        margin-right: 0;
    }
`;
